"use strict";

exports.__esModule = true;
exports.isSupportsFutureOrder = isSupportsFutureOrder;
exports.getSupportedDispatchTypes = getSupportedDispatchTypes;
exports.getDelayMins = getDelayMins;
exports.hasNoAvailableDispatchType = hasNoAvailableDispatchType;
exports.getAllBusinessNotifications = getAllBusinessNotifications;
exports.getCurbsideInfo = exports.getIsCurbsideEnabled = exports.isNoPhysicalLocation = void 0;

var _dispatchTypeLogic = require("./dispatchTypeLogic");

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _Status = _interopRequireDefault(require("@wix/wixrest-utils/dist/openrest-helpers/Status"));

var _lodash = _interopRequireDefault(require("lodash"));

var _availability = require("availability");

var _BusinessNotifications = require("../types/BusinessNotifications");

var _constants = require("../constants");

var _dateTimeLogic = require("./dateTimeLogic");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isSupportsFutureOrder(restaurant) {
  return !restaurant.orders.future.disabled;
}

function getSupportedDispatchTypes({
  deliveryInfos,
  deliveryDisplayableMenu,
  getVirtualDispatchTypes
}) {
  return deliveryInfos.reduce((deliveryTypes, deliveryInfo) => {
    const _StatusHelper$getStat = _Status.default.getStatus(deliveryInfo.availability, (0, _momentTimezone.default)()),
          status = _StatusHelper$getStat.status,
          reason = _StatusHelper$getStat.reason;

    const isClosed = status === 'unavailable' && reason === 'closed';
    const foundDeliverableItems = !deliveryDisplayableMenu || (0, _dispatchTypeLogic.hasAnyDeliverableItems)(deliveryDisplayableMenu);

    if (deliveryInfo.type !== 'premises' && !deliveryInfo.inactive && !isClosed && (deliveryInfo.type !== 'delivery' || foundDeliverableItems)) {
      deliveryTypes.add(deliveryInfo.type);

      if (getVirtualDispatchTypes && deliveryInfo.type === 'takeout' && deliveryInfo.contactlessDineInInfo && deliveryInfo.contactlessDineInInfo.enabled) {
        deliveryTypes.add('dine-in');
      }
    }

    return deliveryTypes;
  }, new Set());
}

function getDelayMins({
  deliveryInfos,
  dispatchType
}) {
  const areas = _lodash.default.filter(deliveryInfos, info => info.type === dispatchType && !info.inactive);

  const delayMins = _lodash.default.keys(_lodash.default.groupBy(_lodash.default.map(_lodash.default.map(areas, 'delayMins'), delayMin => {
    return delayMin || 0;
  })));

  return _lodash.default.map(delayMins, d => parseInt(d, 10));
}

function hasNoAvailableDispatchType(restaurant, calendar) {
  const isTakeoutAvailable = Boolean(restaurant.deliveryInfos.find(di => di.type === 'takeout' && (0, _availability.isAvailableOn)(di.availability, calendar)));
  const isTakeoutAvailableAnytime = Boolean(restaurant.deliveryInfos.find(di => di.type === 'takeout' && !di.inactive));
  const isDeliveryAvailable = Boolean(restaurant.deliveryInfos.find(di => di.type === 'delivery' && (0, _availability.isAvailableOn)(di.availability, calendar)));
  const isDeliveryAvailableAnytime = Boolean(restaurant.deliveryInfos.find(di => {
    const _StatusHelper$getStat2 = _Status.default.getStatus(di.availability, (0, _momentTimezone.default)()),
          status = _StatusHelper$getStat2.status,
          reason = _StatusHelper$getStat2.reason;

    const isClosed = status === 'unavailable' && reason === 'closed';
    return di.type === 'delivery' && !isClosed;
  }));
  return !isTakeoutAvailableAnytime && !isDeliveryAvailableAnytime || !isTakeoutAvailable && !isDeliveryAvailable && !isSupportsFutureOrder(restaurant);
}

function getAllBusinessNotifications(restaurant, hasAnyPaymentMethods, dispatchTime) {
  const calendar = (0, _momentTimezone.default)(dispatchTime).tz(restaurant.timezone);

  const restStatus = _Status.default.getStatus(restaurant.openTimes, calendar);

  const notifications = [];

  if (!hasAnyPaymentMethods) {
    notifications.push({
      notification: {
        notification: _BusinessNotifications.BusinessNotifications.NoPaymentMethods
      },
      weight: 1100
    });
  }

  if (!isPremiumRestaurant(restaurant)) {
    notifications.push({
      notification: {
        notification: _BusinessNotifications.BusinessNotifications.NotPremium
      },
      weight: 1000
    });
  }

  if (isNoPhysicalLocation(restaurant.address)) {
    notifications.push({
      notification: {
        notification: _BusinessNotifications.BusinessNotifications.NoPhysicalLocation
      },
      weight: 900
    });
  }

  if (restStatus.status === 'unavailable') {
    const hasAvailableDateAndTimes = (0, _dateTimeLogic.getAvailableTimingOptions)(restaurant, 'delivery').includes('later') || (0, _dateTimeLogic.getAvailableTimingOptions)(restaurant, 'takeout').includes('later');
    const closedNotifications = isSupportsFutureOrder(restaurant) && hasAvailableDateAndTimes ? _BusinessNotifications.BusinessNotifications.OnlyFutureOrders : _BusinessNotifications.BusinessNotifications.RestaurantClosed;
    notifications.push({
      notification: {
        notification: closedNotifications
      },
      weight: 800
    });
  }

  const oloStatus = _Status.default.getStatus(_lodash.default.get(restaurant, 'orders.availability'), calendar);

  if (oloStatus.status === 'unavailable' || hasNoAvailableDispatchType(restaurant, calendar)) {
    const locale = restaurant.locale;

    const comment = _lodash.default.get(oloStatus, `comment[${locale}]`);

    notifications.push({
      notification: {
        notification: _BusinessNotifications.BusinessNotifications.OlOunavailable,
        comment
      },
      weight: 600
    });
  }

  notifications.sort((a, b) => b.weight - a.weight);
  return notifications.map(nd => nd.notification);
}

function isPremiumRestaurant(restaurant) {
  return _lodash.default.find(restaurant.products, {
    id: 'com.wix.restaurants.orders',
    param: 'premium'
  });
}

const isNoPhysicalLocation = address => {
  return address && (address.formatted === _constants.NO_ADDRESS || address.formatted === _constants.DEFAULT_ADDRESS || address.formatted === _constants.DEFAULT_ADDRESS_SHORT);
};

exports.isNoPhysicalLocation = isNoPhysicalLocation;

const getIsCurbsideEnabled = deliveryInfos => {
  return deliveryInfos.some(deliveryInfo => {
    var _deliveryInfo$curbsid;

    return deliveryInfo.type === 'takeout' && ((_deliveryInfo$curbsid = deliveryInfo.curbsideInfo) == null ? void 0 : _deliveryInfo$curbsid.enabled);
  });
};

exports.getIsCurbsideEnabled = getIsCurbsideEnabled;

const getCurbsideInfo = deliveryInfos => {
  var _takeoutDispatchInfo$;

  const dispatchInfo = deliveryInfos.find(deliveryInfo => deliveryInfo.type === 'takeout');
  const takeoutDispatchInfo = dispatchInfo;
  return takeoutDispatchInfo && (_takeoutDispatchInfo$ = takeoutDispatchInfo.curbsideInfo) != null && _takeoutDispatchInfo$.enabled ? takeoutDispatchInfo.curbsideInfo : undefined;
};

exports.getCurbsideInfo = getCurbsideInfo;
//# sourceMappingURL=restaurantLogic.js.map